// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Us8R","item":"PaymentsMobile_item__1c8iA","label":"PaymentsMobile_label__1BmZQ","amount":"PaymentsMobile_amount__2ilNL"};